import {createReducer, Reducer} from "redux-act";
import {ITranslationsReducer} from "modules/types";
import {fetchTranslationsSuccessAction} from "modules/actions/translations";

const initialState: ITranslationsReducer[] = [];

export const translations: Reducer<ITranslationsReducer[]> = createReducer({}, initialState);
translations.on(fetchTranslationsSuccessAction, (state, payload) => payload);
